// import { formatDate } from '../helpers/date';
import { getQuote } from '../services/galeno';

// constants
const initialState = {
  fetching: false,
  error: '',
  galeno: {},
  cover: {}
};

export const FETCH_QUOTE_SUCCESS = 'FETCH_QUOTE_SUCCESS';
export const FETCH_QUOTE_PENDING = 'FETCH_QUOTE_PENDING';
export const FETCH_QUOTE_FAILURE = 'FETCH_QUOTE_FAILURE';
export const SELECT_COVER = 'SELECT_COVER';

// actions
export const fetchQuote = (car) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_QUOTE_PENDING });
      const quote = await getQuote(car);
      dispatch({ type: FETCH_QUOTE_SUCCESS, payload: quote });
    } catch (error) {
      const err = error.message;
      dispatch({ type: FETCH_QUOTE_FAILURE, payload: err });
    }
  };
};

export const selectCover = (cover) => {
  return {
    type: SELECT_COVER,
    payload: cover
  };
};

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_QUOTE_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_QUOTE_SUCCESS:
      return {
        ...state,
        fetching: false,
        galeno: action.payload,
        error: ''
      };
    case FETCH_QUOTE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload
      };
    case SELECT_COVER:
      return {
        ...state,
        cover: action.payload
      };
    default:
      return state;
  }
}
